/* DSL Video autoplay-on-scroll voor data-autoplay-scroll videos */
(function(){
  if (!("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio > 0.6) v.play().catch(function(){});
      else v.pause();
    });
  }, {threshold: [0, 0.6, 1]});
  document.querySelectorAll("video[data-autoplay-scroll]").forEach(function(v){
    v.muted = true; v.playsInline = true;
    io.observe(v);
  });
})();